import * as utils from '../../../shared/utils';

const getSizeTitle = ({ operator, value, title = '' }) => {
  const sizeOperators = {
    between: () => {
      const dates = value.map((s) => utils.bytesToSize(Number(s)));
      return `${dates[0]} - ${dates[1]}`;
    },
    gt: () => `> ${utils.bytesToSize(Number(value))}`,
    lt: () => `< ${utils.bytesToSize(Number(value))}`,
    equals: () => `= ${utils.bytesToSize(Number(value))}`,
    notEquals: () => `≠ ${utils.bytesToSize(Number(value))}`,
  };

  return sizeOperators[operator]?.() || title;
};

export default getSizeTitle;
